"use strict";
// tslint:disable:jsx-no-lambda
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onMenuItemClick = exports.renderMenuList = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const Logo_1 = __importDefault(require("../Logo/Logo"));
const Menu_1 = __importDefault(require("../Menu/Menu"));
const ImpersonationController_1 = require("../Menu/OrganizationBox/ImpersonationController");
const MobileMenu_1 = __importDefault(require("./MobileMenu"));
const OperatorHeader_1 = __importDefault(require("./OperatorHeader"));
const actOnBehalfMode_1 = require("./util/actOnBehalfMode");
const getEnvironment_1 = require("./util/getEnvironment");
const AioPage = (props) => {
    var _a;
    const [open, setOpen] = react_1.useState(false);
    const [isMenuCollapsed, setIsMenuCollapsed] = react_1.useState();
    const toggleOpen = () => setOpen(!open);
    const closeMobileMenu = () => setOpen(false);
    const navigateToOperatorPage = () => {
        const { actOnBehalfOrganizationId, actOnBehalfModeFromOrigin } = actOnBehalfMode_1.getActOnBehalfMode();
        let environment = getEnvironment_1.getEnvironment() + '.';
        if (environment === 'prod.') {
            environment = '';
        }
        if (environment === 'local.') {
            environment = 'test.';
        }
        const baseURL = `https://${environment}autopay.io/`;
        let operatorPageURL = baseURL;
        switch (actOnBehalfModeFromOrigin) {
            case 'tenant':
                operatorPageURL += `operator/tenant/${encodeURIComponent(actOnBehalfOrganizationId !== null && actOnBehalfOrganizationId !== void 0 ? actOnBehalfOrganizationId : '')}`;
                break;
            case 'landlord':
                operatorPageURL += `operator/landlords/${encodeURIComponent(actOnBehalfOrganizationId !== null && actOnBehalfOrganizationId !== void 0 ? actOnBehalfOrganizationId : '')}`;
                break;
            case 'search':
                operatorPageURL += 'customerservice/operator/search';
                break;
        }
        let validatedURL;
        try {
            validatedURL = new URL(operatorPageURL).href;
        }
        catch (_) {
            validatedURL = baseURL;
        }
        actOnBehalfMode_1.exitActOnBehalfMode();
        window.location.href = validatedURL;
    };
    const renderHeader = () => {
        if (props.type === 'page-with-sidebar') {
            return;
        }
        const header = props.header;
        const headerColor = header === null || header === void 0 ? void 0 : header.style;
        let headerClassName = 'aio-header';
        if (headerColor === 'orange') {
            headerClassName += ' aio-header-orange';
        }
        else if (headerColor === 'blue') {
            headerClassName += ' aio-header-blue';
        }
        return (React.createElement("div", { className: headerClassName },
            React.createElement("div", { className: "aio-header-left" },
                React.createElement(Logo_1.default, { color: headerColor === 'blue' ? 'white' : 'blue' }),
                React.createElement("div", { className: "aio-header-left-inner" }, header && header.left && header.left.map((el, i) => React.createElement("div", { key: i + '-left' }, el.element)))),
            React.createElement("div", { className: "aio-header-right" }, header && header.right && header.right.map((el, i) => React.createElement("div", { key: i + '-right' }, el.element)))));
    };
    const renderMobileMenu = () => {
        const header = props.header;
        if (!header) {
            return React.createElement(MobileMenu_1.default, { open: open, toggleOpen: toggleOpen });
        }
        let elements = [];
        if (header.left) {
            elements = elements.concat(header.left.filter((el) => el.hideOnMobile !== true));
        }
        if (header.right) {
            elements = elements.concat(header.right.filter((el) => el.hideOnMobile !== true));
        }
        if (elements.length > 0) {
            return (React.createElement(MobileMenu_1.default, { elements: elements, open: open, toggleOpen: toggleOpen }));
        }
        return React.createElement(MobileMenu_1.default, { open: open, toggleOpen: toggleOpen });
    };
    if (props.type === 'page-with-sidebar' && props.sidebar) {
        const { actOnBehalfOrganizationId, actOnBehalfOrganizationType } = actOnBehalfMode_1.getActOnBehalfMode();
        return (React.createElement("div", { className: `aio-page${open ? ' aio-page-open' : ''}${isMenuCollapsed ? ' aio-page-collapsed-menu' : ''}` },
            React.createElement(Menu_1.default, Object.assign({}, props.sidebar, { open: open, setIsMenuCollapsed: setIsMenuCollapsed, toggleOpen: toggleOpen, closeMobileMenu: closeMobileMenu, impersonationController: (actOnBehalfOrganizationId && actOnBehalfOrganizationType) ?
                    React.createElement(ImpersonationController_1.ImpersonationController, { organizationName: (_a = props.sidebar.organization) === null || _a === void 0 ? void 0 : _a.current.organizationName, organizationType: actOnBehalfOrganizationType, onClose: navigateToOperatorPage }) : undefined })),
            React.createElement("div", { className: "aio-page-right-container" },
                React.createElement(OperatorHeader_1.default, { menuProps: props.sidebar }),
                React.createElement("div", { className: `aio-page-main main-container${props.sidebar.currentMode === 'operator' ? '-operator' : ''}` }, props.children))));
    }
    else if (props.type === 'panel-page') {
        return (React.createElement("div", { className: "aio-page aio-panel-page" },
            renderMobileMenu(),
            renderHeader(),
            React.createElement("div", { className: "aio-body-with-panel" },
                React.createElement("div", { className: "aio-panel" }, props.children))));
    }
    else if (props.type === 'blank-page') {
        return (React.createElement("div", { className: "aio-page aio-blank-page" }, props.children));
    }
    else if (props.type === 'centered-panel-page-full-height' || props.type === 'centered-panel-page') {
        return (React.createElement("div", { className: "aio-page aio-centered-panel-page" },
            React.createElement("div", { className: "aio-centered-panel-header" },
                React.createElement(Logo_1.default, { color: "blue" })),
            React.createElement("div", { className: `aio-centered-panel ${props.type === 'centered-panel-page' ?
                    'centered-panel-dynamic-height' : 'centered-panel-full-height'}` }, props.children)));
    }
    else {
        return (React.createElement("div", { className: "aio-page" },
            renderMobileMenu(),
            React.createElement("div", { className: "aio-page-main" },
                renderHeader(),
                React.createElement("div", { className: "aio-body" }, props.children))));
    }
};
const renderMenuList = (sidebarMenuItems) => {
    return (React.createElement("ul", { className: "menu-list" }, sidebarMenuItems.map((item) => {
        return (React.createElement("li", { key: item.label, className: window.location.pathname === item.url ? 'active' : '' }, item.externalLink === false ? (React.createElement(react_router_dom_1.Link, { to: item.url, onClick: (e) => exports.onMenuItemClick(e, item) }, item.label)) : (React.createElement("a", { href: item.url, onClick: (e) => exports.onMenuItemClick(e, item) }, item.label))));
    })));
};
exports.renderMenuList = renderMenuList;
const onMenuItemClick = (e, item) => {
    if (item.onClick) {
        e.preventDefault();
        item.onClick();
    }
};
exports.onMenuItemClick = onMenuItemClick;
exports.default = AioPage;
//# sourceMappingURL=AioPage.js.map